import React from 'react'

export const SocialLinks = ({ website, scholar, LinkedIn, researchGate, github, orcid }) => {
  const links = [
    { href: website, icon: 'fa-solid fa-house', label: 'Website' },
    { href: scholar, icon: 'ai ai-google-scholar', label: 'Google Scholar' },
    { href: LinkedIn, icon: 'fa-brands fa-linkedin-in', label: 'LinkedIn' },
    { href: researchGate, icon: 'fa-brands fa-researchgate', label: 'ResearchGate' },
    { href: github, icon: 'fa-brands fa-github', label: 'GitHub' },
    { href: orcid, icon: 'fa-brands fa-orcid', label: 'ORCID' },
  ].filter((l) => l.href)

  if (!links.length) return null

  return (
    <div className='social-row'>
      {links.map((l) => (
        <a
          key={l.label}
          href={l.href}
          target='_blank'
          rel='noreferrer'
          aria-label={l.label}
          title={l.label}
        >
          <i className={l.icon} />
        </a>
      ))}
    </div>
  )
}

const StudentCard = (props) => {
  const { name, position, interests, img, website, achievements = [] } = props
  const items = achievements.filter((a) => a && a.trim())

  let photo = null
  try {
    photo = require(`../resources/${img}`)
  } catch (e) {
    photo = null
  }

  // With a personal site, the photo and name link to it.
  const toSite = (children) =>
    website ? (
      <a href={website} target='_blank' rel='noreferrer'>
        {children}
      </a>
    ) : (
      children
    )

  return (
    <article className={`person ${website ? 'person--linked' : ''}`}>
      <div className='person__photo'>
        {photo && toSite(<img src={photo} alt={name} loading='lazy' />)}
      </div>
      <div className='person__body'>
        <h3 className='person__name'>{toSite(name)}</h3>
        <p className='person__role'>{position}</p>
        {website && (
          <a
            className='person__site'
            href={website}
            target='_blank'
            rel='noreferrer'
          >
            <i className='fa-solid fa-globe' />
            {website.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '')}
            <i className='fa-solid fa-arrow-up-right-from-square' />
          </a>
        )}

        {interests && (
          <>
            <div className='person__label'>Research</div>
            <p className='person__interests'>{interests}</p>
          </>
        )}

        {items.length > 0 && (
          <ul className='person__achievements'>
            {items.map((a) => (
              <li key={a}>
                <i className='fa-solid fa-award' />
                {a}
              </li>
            ))}
          </ul>
        )}

        <SocialLinks {...props} />
      </div>
    </article>
  )
}

export default StudentCard
